/*
	La hora de WAPP es la de la Ciudad de México, esté donde esté la computadora (Esteban, 2026-09-24:
	"las horas en asistencias no parecen estar con horario CDMX y deberían, en todos lados").

	Un new Date() a secas trae la hora de la computadora: con la Mac en otra zona, "hoy", el día de la
	semana y la jornada salían corridos. Honduras usa la misma hora que CDMX (UTC-6, sin horario de
	verano), así que esta sirve para todos los planteles.

	ahoraCdmx() devuelve un Date cuyos getFullYear/getMonth/getDate/getDay/getHours/getMinutes dicen la
	hora de CDMX. Es para CALCULAR (hoy, día de la semana, jornada, edad, fecha por defecto). No se debe
	mandar al servidor con toISOString() como si fuera un instante: para mandar "hoy", usar hoyCdmx().
*/
const ZONA = "America/Mexico_City"

const formato = new Intl.DateTimeFormat("en-CA", {
	timeZone : ZONA, hourCycle : "h23",
	year : "numeric", month : "2-digit", day : "2-digit", hour : "2-digit", minute : "2-digit", second : "2-digit"
})

/** Año, mes (1-12), día, hora, minuto y segundo de CDMX para un instante (por defecto, ahora). */
export const piezasCdmx = (instante : Date = new Date()) =>
{
	const p : {[tipo : string] : number} = {}
	formato.formatToParts(instante).forEach((parte) => { if(parte.type !== "literal") p[parte.type] = +parte.value })
	return {anio : p.year, mes : p.month, dia : p.day, hora : p.hour % 24, minuto : p.minute, segundo : p.second}
}

/** "Ahora" con las piezas de CDMX (ver arriba: para calcular, no para mandar como instante). */
export const ahoraCdmx = () : Date =>
{
	const p = piezasCdmx()
	return new Date(p.anio, p.mes - 1, p.dia, p.hora, p.minuto, p.segundo)
}

/** Hoy en CDMX como "2026-09-24". */
export const hoyCdmx = () : string =>
{
	const p = piezasCdmx()
	return p.anio + "-" + String(p.mes).padStart(2, "0") + "-" + String(p.dia).padStart(2, "0")
}
